"use client";

import { type ReactNode, use } from "react";

import { cn } from "../../utils";
import { LayoutContextProvider } from "./context";

export interface LayoutContentBodyProps {
  className?: string;
  children: ReactNode;
}

const ContentBody = ({ className, children }: LayoutContentBodyProps) => {
  const layout = use(LayoutContextProvider);

  return (
    <div
      ref={layout?.setContentBodyElement}
      className={cn(
        "layout-content-body relative flex size-full flex-1 flex-col overflow-auto bg-neutral-98",
        className
      )}
    >
      {children}
    </div>
  );
};

export default ContentBody;
